import React, { useState, useEffect, useRef } from 'react';
import TrainBullet from './components/TrainBullet';

export const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export const replaceTrainBulletsInParagraphs = (trains, arrayOfStrs) => {
  return arrayOfStrs.map((str, i) => {
    let tmp = [str.replace(/ - /g, "–")];
    let matched;
    while (matched = tmp.find((c) => typeof c === 'string' && c.match(/\<[A-Z0-9]*\>/))) {
      const regexResult = matched.match(/\<([A-Z0-9]*)\>/);
      let j = tmp.indexOf(matched);
      const selectedTrainBullet = (<TrainBullet id={regexResult[1]} key={`${i}-${regexResult[1]}`} trains={trains} size='small' />);
      const parts = matched.split(regexResult[0]);
      let newMatched = parts.flatMap((x) => [x, selectedTrainBullet]);
      newMatched.pop();
      tmp[j] = newMatched;
      tmp = tmp.flat();
    }

    return (<p key={i}>{tmp}</p>);
  });
};